var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-holder"},[_c('div',{staticClass:"bar-background"}),_c('div',{class:_vm.barClass(_vm.value)}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }